module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "user-profile dropdown-toggle"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.photoUrl,
      "alt": ""
    }
  }), _vm._v("\n    " + _vm._s(_vm.user.first) + " " + _vm._s(_vm.user.last) + "\n    "), _c('span', {
    staticClass: " fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-usermenu pull-right"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out pull-right"
  }), _vm._v(" Log Out")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3868e74f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserPanel.vue
// module id = 340
// module chunks = 1